// Shared inbox search string for realtime refetches. Building/org come from Redux
// refs in ChatRealtime; search lives in ChatPanel local state, so this bridges them.
let inboxSearchQ = '';

export const setChatInboxSearchQ = (q = '') => {
  inboxSearchQ = String(q || '');
};

export const getChatInboxSearchQ = () => inboxSearchQ;
